import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Welcome from "./pages/Welcome";
import Dashboard from "./pages/Dashboard";
import Contests from "./pages/Contests";
import ContestLobby from "./pages/ContestLobby";
import BuildLineup from "./pages/BuildLineup";
import Market from "./pages/Market";
import IndexDetail from "./pages/IndexDetail";
import MySeason from "./pages/MySeason";
import Profile from "./pages/Profile";
import RealityMode from "./pages/RealityMode";
import Vault from "./pages/Vault";
import Leaderboard from "./pages/Leaderboard";
import Admin from "./pages/Admin";
import UserProfile from "./pages/UserProfile";
import Requests from "./pages/Requests";
import DuelCreate from "./pages/DuelCreate";
import DuelView from "./pages/DuelView";
import MyDuels from "./pages/MyDuels";

function AppRouter() {
  const loc = useLocation();
  // Detect OAuth callback synchronously BEFORE normal routes
  if (loc.hash && loc.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/contests" element={<ProtectedRoute><Contests /></ProtectedRoute>} />
      <Route path="/contests/:id" element={<ProtectedRoute><ContestLobby /></ProtectedRoute>} />
      <Route path="/contests/:id/build" element={<ProtectedRoute><BuildLineup /></ProtectedRoute>} />
      <Route path="/market" element={<ProtectedRoute><Market /></ProtectedRoute>} />
      <Route path="/heat" element={<ProtectedRoute><Market /></ProtectedRoute>} />
      <Route path="/market/:id" element={<ProtectedRoute><IndexDetail /></ProtectedRoute>} />
      <Route path="/my-season" element={<ProtectedRoute><MySeason /></ProtectedRoute>} />
      <Route path="/my-circles" element={<ProtectedRoute><MySeason /></ProtectedRoute>}/>
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/reality" element={<ProtectedRoute><RealityMode /></ProtectedRoute>} />
      <Route path="/vault" element={<ProtectedRoute><Vault /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/u/:id" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
      <Route path="/requests" element={<ProtectedRoute><Requests /></ProtectedRoute>} />
      <Route path="/duels" element={<ProtectedRoute><MyDuels /></ProtectedRoute>} />
      <Route path="/duel/new" element={<ProtectedRoute><DuelCreate /></ProtectedRoute>} />
      <Route path="/duel/:code" element={<ProtectedRoute><DuelView /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
